import React, { useEffect, useState } from 'react';
import { ButtonWithLoadingIcon } from '../../../components/common/ButtonWithLoadingIcon';
import { LinkButton } from '../../../components/common/LinkButton';
import { RentalReturnStep2 } from './returnStep2';

export const RentalReturnStep3 = ({
  productList,
  onClickNext,
  onClickPrevious,
}) => {
  const data = [
    {
      id: 1,
      title: 'Drop off at any UPS location',
      content:
        'Throw your return(s) back in your tote and drop it off at your nearest UPS location using your prepaid label.',
    },
    // {
    //   id: 2,
    //   title: 'Schedule a pickup',
    //   content: `We'll come to you! Whether you live on-campus or off, select a date and time that works with your schedule.`,
    //   isPickup: true,
    // },
    {
      id: 3,
      title: 'Campus drop-box',
      content: `We're working on making returns even more convenient! Stay tuned for more updates.`,
      isNotActive: true,
    },
  ];
  const [selectedMethod, setSelectedMethod] = useState(null);
  const [error, setError] = useState(null);
  const [dataList, setDataList] = useState(data);

  useEffect(() => {
    setDataList(data);
  }, []);

  const renderButton = () => {
    return (
      <div className={'review-button'}>
        <ButtonWithLoadingIcon
          style={{
            alignSelf: 'center',
            width: '35%',
            marginBottom: 10,
          }}
          type='submit'
          color={'primary'}
          onClick={() => {
            if (onClickNext) {
              if (selectedMethod) {
                onClickNext(selectedMethod);
              } else {
                setError('Please select a method');
              }
            }
          }}
        >
          Next
        </ButtonWithLoadingIcon>
        <LinkButton
          className={'mt-3'}
          style={{
            marginBottom: 10,
            textAlign: 'center',
            width: '100%',
            height: 55,
            cursor: 'pointer',
          }}
          onClick={() => onClickPrevious(selectedMethod)}
        >
          Previous
        </LinkButton>
      </div>
    );
  };
  return (
    <div>
      {dataList?.length > 0 ? (
        dataList?.map((d, index) => {
          return (
            <div
              style={{
                marginBottom: index === dataList.length - 1 ? 15 : 40,
                marginLeft: '2.5rem',
                marginRight: '2.5rem',
              }}
            >
              <div
                className='d-flex list-view flex-direction-column'
                style={
                  selectedMethod === d
                    ? { backgroundColor: '#F5E5D9', flexDirection: 'column' }
                    : d.isNotActive
                    ? {
                        backgroundColor: '#F5E5D9',
                        border: 'none',
                        flexDirection: 'column',
                        cursor: 'none',
                      }
                    : { flexDirection: 'column' }
                }
                area-disabled={d.isNotActive || d.isPickup}
                onClick={() => {
                  if (!d.isNotActive || !d.isPickup) {
                    setError(null);
                    setSelectedMethod(d);
                  }
                }}
              >
                <span
                  style={{ fontFamily: 'Brown', fontSize: 15 }}
                  className='mb-2'
                >
                  {d.isNotActive ? 'COMING SOON' : ''}
                </span>
                <span
                  style={{ fontFamily: 'Brown', fontSize: 22 }}
                  className='mb-2'
                >
                  {d.title || '--'}
                </span>
                <span style={{ fontFamily: 'Brown', fontSize: 16 }}>
                  {d.content || ''}
                </span>
              </div>
            </div>
          );
        })
      ) : (
        <div className='d-flex align-items-center justify-content-center h-100'>
          No product found for return
        </div>
      )}
      {error ? (
        <div style={{ display: 'flex', marginBottom: -25 }}>
          <span
            style={{
              fontSize: '14',
              color: '#F96E4E',
              fontFamily: 'Brown',
              width: '100%',
              textAlign: 'center',
            }}
          >
            {error}
          </span>
        </div>
      ) : null}
      {renderButton()}
    </div>
  );
};
